import React, { useEffect, useState } from "react";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";
import axios from "axios";
import {
  FaUsers,
  FaWallet,
  FaArrowUp,
  FaArrowDown,
  FaBan,
} from "react-icons/fa";
import { base_url } from "./components/AgentWhitelist";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [totalCustomer, setTotalCustomer] = useState("0");
  const [totalagent, setTotalagent] = useState("0");
  const [activeCustomer, setActiveCustomer] = useState("0");

  const [casino, setCasino] = useState([]);
  const [fullCasino, setFullCasino] = useState([]);
  const [bets, setBets] = useState(0);
  const [wins, setWins] = useState(0);
  const [ggr, setGgr] = useState(2);
  const [ggrpercent, setGgrpercent] = useState(0);
  const [currencyGgrList, setCurrencyGgrList] = useState([]);
  const [totalLoss, setTotalLoss] = useState(0);


  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const dashbord = async (req, res) => {
    try {
      const auth = localStorage.getItem("admin");

      const reponse = await axios.get(base_url + "/api/admin/dashdynamic", {
        headers: {
          Authorization: auth,
          "content-type": "application/json",
        },
      });

      const activeCustomers = reponse.data.customers.filter(
        (cust) => cust.status === "Active"
      );

      setActiveCustomer(activeCustomers.length);

      // console.log(reponse.data,"kiki");
      setTotalCustomer(reponse.data.customers.length);
      setTotalagent(reponse.data.agents.length);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    dashbord();
  }, []);

  const fetchCurrencyGgr = async () => {
    try {
      const auth = localStorage.getItem("admin");

      const response = await axios.get(
        base_url + "/api/admin/ggrCurrencyWise",
        {
          headers: {
            Authorization: auth,
            "content-type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setCurrencyGgrList(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCurrencyGgr();
  }, []);

  const userinfo = async (req, res) => {
    try {
      const auth = localStorage.getItem("admin");

      const reponse = await axios.get(base_url + "/api/webapi/userinfo", {
        headers: {
          Authorization: auth,
          "content-type": "application/json",
        },
      });

      console.log(reponse.data.user.ggr, "kiki");

      setGgrpercent(reponse.data.user.ggr);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    userinfo();
  });

  const casinoData = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.get(base_url + "/api/webapi/casinoData", {
        headers: {
          Authorization: auth,
          "content-type": "application/json",
        },
      });

      if (response?.data?.success) {
        const data = response?.data?.result;
const totals = data.reduce(
  (acc, bet) => {
    const amount = Number(bet.amount) || 0;
    const ggr = Number(bet.ggr) || 0;
    const profit = Number(bet.profit) || 0;

    acc.amount += amount;
    acc.ggr += ggr;
    acc.wins += profit;

    // 👉 STATUS 2 = LOSS
    if (Number(bet.status) === 2) {
      acc.loss += amount;
    }

    return acc;
  },
  { amount: 0, ggr: 0, wins: 0, loss: 0 }
);


        setCasino(data);
        setFullCasino(data);

        setBets(totals?.amount);
        setWins(totals?.wins);
        setGgr(Number(totals?.ggr).toFixed(2));
        setTotalLoss(totals?.loss);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    casinoData();
  }, []);
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="wrapper bg-light">
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      <div
        className={`content-wrapper p-3 ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{ marginLeft: !isMobile && isSidebarOpen ? "" : "0" }}
      >
        <div className="dashboard-header">
          <h1>Dashboard</h1>
          <div className="header-info">
            {/* <span>20 Jun 2022 - 20 Jul 2022</span> */}
          </div>
        </div>
        <div className="metrics-grid">
          <div
            className="metric-card cursor-pointer"
            onClick={() => navigate("/admin/casinoReport")}
          >
            <h3>Total Bets </h3>
            <p>  {Number(bets).toFixed(2)}</p>
          </div>
          <div
            className="metric-card cursor-pointer"
            onClick={() => navigate("/admin/casinoReport")}
          >
            <h3>Total users  Winnings</h3>
            <p> {Number(wins).toFixed(2)}</p>
          </div>

           <div
            className="metric-card cursor-pointer"
            onClick={() => navigate("/admin/casinoReport")}
          >
            <h3>Total Panel  Winnings</h3>
            <p> {Number(totalLoss).toFixed(2)}</p>
          </div>
          <div
            className="metric-card cursor-pointer"
            onClick={() => navigate("/admin/casinoReport")}
          >
            <h3>
              Total GGR <span className="change">{ggrpercent}% your ggr</span>
            </h3>
            <p> {Number(ggr).toFixed(2)}</p>
          </div>
            {/* ADMIN CHECK START */}
  {localStorage.getItem("role") === "admin" && (
    <>
      <div className="metric-card cursor-pointer" onClick={() => navigate("/admin/customerWhitelist")}>
        <h3>Total Customers</h3>
        <p>{totalCustomer}</p>
      </div>

      <div className="metric-card cursor-pointer" onClick={() => navigate("/admin/agentWhitelist")}>
        <h3>Total Agents</h3>
        <p>{totalagent}</p>
      </div>

      <div className="metric-card">
        <h3>Active Customers</h3>
        <p>{activeCustomer}</p>
      </div>

      {/* Currency Wise GGR */}
      {currencyGgrList.map((item, index) => (
        <div className="metric-card" key={index}>
          <h3>Total GGR ({item.currency})</h3>
          <p> {Number(item.totalGGR).toFixed(2)}</p>
        </div>
      ))}
    </>
  )}
  {/* ADMIN CHECK END */}
        </div>
        {/* <div className="charts">
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;
